export default __webpack_public_path__ + "static/media/shot2.ec1a7a91.jpg";